import { useEffect } from 'react';

interface JsonLdData {
  [key: string]: unknown;
}

interface SEOMetaProps {
  title: string;
  description: string;
  canonical: string;
  ogType?: string;
  jsonLd?: JsonLdData | JsonLdData[];
  lang?: string;
}

export default function SEOMeta({
  title,
  description,
  canonical,
  ogType = 'website',
  jsonLd,
  lang = 'en',
}: SEOMetaProps) {
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content={lang === 'zh' ? 'zh_CN' : 'en_US'} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {jsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      )}
    </>
  );
}
